import { useAuth } from 'hooks/auth/useAuth';

import { Subject } from '@/lib/auth/permissions/permissions-service';

export interface EnforcementStatementAccess {
  canRead: boolean;
  canWrite: boolean;
}

/**
 * Reads the token's own permissions, not `hasPermission`: the API requires the
 * permission in the token on these routes and the super-admin role alone does
 * not pass, so an action must not be offered on the strength of that role.
 */
export function useEnforcementStatementAccess(): EnforcementStatementAccess {
  const { permissions } = useAuth();
  return {
    canRead: permissions?.includes(`read:${Subject.REVENUE}`) ?? false,
    canWrite: permissions?.includes(`write:${Subject.REVENUE}`) ?? false,
  };
}
